export default __webpack_public_path__ + "static/media/Pending_icon.f204d9c6.svg";